import './src/styles/global.scss';
import './src/styles/variables.scss';

export { wrapRootElement } from './src/hooks/useAuth';
